/* eslint-disable */
import React from 'react';
import {CFWebSocket, createURL} from './cf/cfwebsocketChannel';
import * as gameTimeActions from "src/actions/gameTime";
import * as gameTimeTeamActions from 'src/actions/gameTimeTeamActions'
import store from 'src/store';
import {updateWebSocketData} from "src/actions/websocketActions";
import {appSettingModel} from "src/datamodels/foundation";
import {updateDataStore} from "src/actions/foundationActions";
//import {createWebSocketSingleton} from "src/containers/gameTime/common/gameTimeFunctions";

let keepAlive = null;

let mapper={
    "gameTimeActions":gameTimeActions,
    "gameTimeTeamActions":gameTimeTeamActions
    //"eyesOnActions":eyesOnActions
};

export const getNewWebSocket = () =>{
    return CFWebSocket;
};

const CFWS = CFWebSocket;

const applicationID="websocketland";
//4102AE99E1A70A12D900FC4BC802DEBB
export const wsOptions = {
    "OnClose":(evt) => openClose(evt),
    "OnMessage":(evt) => defaultmsgHandler(evt),
    "OnWelcome":(evt) => openHandler(evt),
    appName:applicationID,
    cfAuth:'',
    onError:(evt) => errorHandler(evt),
    referrer:"/",
    subscribeTo:"",
    url:""
};

export const createWebSocketSingleton = () => {
    let newWebsocket =createWebSocket();
    if(newWebsocket){
        store.dispatch(updateWebSocketData({websocket:newWebsocket}));
    }
};

//tested
export const createWebSocket = () =>{
    let wsStruct = appSettingModel().wsURL?.hasOwnProperty(self.location.hostname) ? appSettingModel().wsURL[self.location.hostname] : {};
    return CFWS.init(
        'gameTime',
        applicationID,
        false,
        wsOptions.cfAuth,
        '',
        wsOptions.OnMessage,
        wsOptions.OnWelcome,
        wsOptions.OnClose,
        wsOptions.onError,
        self.location.pathname,
        wsStruct.secure,
        wsStruct.domain,
        wsStruct.port
    );
};

export const webSocketState = () => {
    let stateData = store.getState();
    return stateData.webSocketData?.websocket?.wsConnection?.readyState
};

export const openConnection = () => {
    let storeData = store.getState();
    //eslint-disable-next-line
    let wsStruct = storeData.appSettings.wsURL.hasOwnProperty(self.location.hostname) ? storeData.appSettings.wsURL[self.location.hostname] : '';
    let url = createURL(false,wsStruct.domain,wsStruct.secure,wsStruct.port);
    storeData.webSocketData.websocket.open(url,wsOptions);
};

const sendSubscribe = (channel,subscribeMessage) => {
    let storeData=store.getState();
    storeData.webSocketData.websocket.subscribe(channel, subscribeMessage);
};
//tested
export const subscribeChannel = (channel,data={},callback=sendSubscribe) => {
    let storeData=store.getState();
    let retme={success:false,subs:[]};
    if(storeData.webSocketData.websocket) {
        let subscribeMessage = createSubscribeMessage(data);
        retme.subs.push("createSubscribeMessage");
        registerSubscriptionAttempt(channel);
        retme.subs.push("registerSubscriptionAttempt");
        callback(channel,subscribeMessage);
        retme.success=true;
    }
    else{
        retme.success = false;
    }
    return retme;
};

//tested
export const createSubscribeMessage = (data) => {
    let storeData=store.getState();
    data.token=storeData.user.token;
    data.domain=appSettingModel().domainCode;
    return data;
};

//tested
export const registerSubscriptionAttempt = (channel) => {
    let storeData=store.getState();
    let ourChannel = channel.split('.')[1];
    let subs = Object.assign({}, storeData.webSocketData.subscriptions);
    subs[ourChannel] = {subscribed: 2};
    store.dispatch(updateWebSocketData({subscriptions: subs}));
};

const sendUnsubscribe = (channel) => {
    let storeData=store.getState();
    if(storeData.webSocketData && storeData.webSocketData.websocket) {
        try{storeData.webSocketData.websocket.unsubscribe(channel);}catch(err){}
    }
};

//tested
export const unsubscribeChannel = (channel,callBack) => {
    let retme=[];
    sendUnsubscribe(channel);
    retme.push("sendUnsubscribe");
    if(callBack) {
        callBack(channel);
        retme.push("callback");
    }
    return retme;
};

export const getSubscriptions = (callback) => {
    let currentStore = store.getState();

    if(currentStore.webSocketData.websocket) {
        try {
            currentStore.webSocketData.websocket.getSubscriptions((e) => {
                syncSubscriptions(e);
                if (callback) {
                    callback(e)
                }
            });
        }
        catch(err){}
    }
};

const syncSubscriptions = (e) => {
    console.dir("In sync subscriptois");
    //console.dir(e);
    let newsubscriptions={};
    e.channels.map((channel)=>{
        let item = channel.split('.');
        //console.dir(item);
        newsubscriptions[item[1]]={subscribed:1}
    });
    store.dispatch(updateWebSocketData({subscriptions:newsubscriptions}));
    //requestChannelUpdate(newsubscriptions);
};

export const getSubscriberCount = (channel,data) => {
    let currentStore = store.getState();
    currentStore.webSocketData.websocket.getSubscriberCount(channel, data);
};

export const publishMessage = (channel,message) => {
    if(channel) {
        let currentStore = store.getState();
        if(currentStore.webSocketData.websocket){
            currentStore.webSocketData.websocket.publish(channel, message);
        }
    }
};

export const requestChannelUpdate = (subscriptions) => {
    console.dir("requesting Channel Update");
    for(let sub in subscriptions){
        if(subscriptions.hasOwnProperty(sub) && subscriptions[sub].subscribed===1) {
            let timer=new Date();
            let currentStore = store.getState();
            publishMessage(`games.` + sub, {
                scope: "gameTimeActions",
                method: "requestSocketUpdate",
                message: {clientid: currentStore.webSocketData.clientid,
                    personid:currentStore.user.personid,
                    displayName:currentStore.user.firstname,
                    time: timer.getTime()
                }
            });
        }
    }
    //
};

export const createPublishAnnouncement = (scopeName,funcName,message)=>{
    return {scope:scopeName,method:funcName,message:message,originalSender:''}
};

export const obtainAction = (scope, method,msg="") => {
    let func = mapper[scope];
    return func && func.hasOwnProperty(method) ? func[method](msg) : null;
};


export const defaultmsgHandler= (evt) => {
    switch (evt.type) {
        case "data":
            if(shouldReceive(evt)) {
                let msg = Object.assign({},evt.data.message);
                delete msg["originalSender"];
                let returnedAction = obtainAction(evt.data.scope,evt.data.method,msg);
                if(returnedAction) {
                    store.dispatch(returnedAction);
                }
                else {
                    //console.dir("failed to run  " + evt.data.scope);
                }
            }
            break;
        case "response":
            processResponse(evt);
            break;
        default:
            ////console.dir("No type of event");
            ////console.dir(evt);
            break;
    }
};
//tested
export const shouldReceive = (evt) =>{
    let storeData = store.getState();
    return (storeData.webSocketData.clientid && evt.hasOwnProperty("publisherid") &&
        parseInt(evt.publisherid.trim()) !== parseInt(storeData.webSocketData.clientid.trim()));
};

//tested
export const processResponse = (evt ) => {
    let retme=[];
    if(evt.reqType==='subscribe'){
        if(evt.code===0){
            getSubscriptions();
            retme.push("getSubscriptions");
        }

    }
    else if(evt.reqType==='unsubscribe'){
        if(evt.code ===0){
            getSubscriptions();
            retme.push("getSubscriptions");
        }
        /*
        let ourChannel=channel.split('.')[1];
    let currentStore = store.getState();
    let subs= Object.assign({},currentStore.webSocketData.subscriptions);
    subs[ourChannel]={subscribed:0};
    updateWebSocketData({subscriptions:subs});
         */

    }
    else if(evt.reqType==='welcome'){
        setClientid(evt.clientid);
        retme.push("setClientid");
    }
    else if(evt.reqType==='publish'){

    }
    else if(evt.reqType==='getSubscriberCount'){
        //props.updateSession({channel:evt.channel,count:evt.subscriberCount})
    }
    return retme;
};


//tested
export const setClientid = (newid) => {
    store.dispatch(updateWebSocketData({clientid:newid}));

};

export const openHandler = () => {
    let stateData = store.getState();
    store.dispatch(updateWebSocketData({status:"open"}));
    clearTimeout(stateData.dataStore.keepAlive);
    store.dispatch(updateDataStore({keepAlive:setInterval(()=>{getSubscriptions()},30000)}));
};

export const openClose= () => {
    store.dispatch(updateWebSocketData({status:"closed"}));
};

export const errorHandler = (evt) => {
    //console.dir("Error in websocket land");
    //console.dir(evt);
    //let createWebSocketSingleton = createWebSocketSingleton;
    let retme=[];
        if(evt && evt.hasOwnProperty("reqType") && evt.reqType==='subscribe') {
            if (evt.msg.indexOf("already subscribed") > -1) {
                getSubscriptions();
                retme.push("getSubscriptions");
            }
        }
        else{
            if(!evt){

            }
        }
    return retme;

};
